import { FavoritesDisplayState } from './display.types';

export const getDefaultDisplay = (): FavoritesDisplayState => ({
  isFiltersDialogOpen: false,
});

export const displayInitialState: FavoritesDisplayState = getDefaultDisplay();
